import { ITeamLeadPodTypeJson } from '@scale/shared/types/expertManagement';
import { ITagJson } from '@scale/shared/types/tag';
import { useMutation } from 'react-query';
import apiFetch from 'react-scale/lib/api-fetch';

export const useUpdatePodType = () => {
  return useMutation([`updatePodType`], (podType: ITeamLeadPodTypeJson) =>
    apiFetch(null, `internal/expert-management/podTypes`, {
      method: 'PUT',
      body: {
        ...podType,
        associatedTags: (podType.associatedTags ?? []).map(tag => (tag as ITagJson)._id),
      },
    }),
  );
};
